import "./Collections.module.css";
import Header from "@/reusable_sections/Header";
import OurCases from "./sections/OurCases";
import JoyasDeLaBiodiversidad from "./sections/JoyasDeLaBiodiversidad";
import OurTermiteServices from "./sections/OurTermiteServices";
import Footer from "@/reusable_sections/Footer";
export default function CollectionsPage() {
  return <div>
      <Header />
      <OurCases />
      <OurTermiteServices />
      <JoyasDeLaBiodiversidad />
      <Footer />
    </div>;
}